<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div class="p-20 text-center">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <img src="assets/invite-sent-icon.svg" alt="sent">
        <h3 class="bold header_title dark-blue">Mail renvoyé</h3>
      </div>

      <div class="p-20">
        <p class="dark-blue no-margin mb-10 text-center">Invitation renvoyé à <span class="light-blue">{{contactInvited}}</span></p>

        <textarea *ngIf="messageAttached" class="w-full text-md dark-blue pap-input no-resize"
         name="message" id="message" style="height: 70px; cursor: default;" [value]="messageAttached" readonly></textarea>
      </div>


      <div class="p-20 margin-center">
        <v8te-active-button [buttonText]="'Ok'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
          [border]="'solid 1px #D9D9D9'" [active]="true" (click)="onDismiss(true)" [height]="50" [minWidth]="190"
          [widthPercent]="50" [bold]="true"></v8te-active-button>
      </div>
    </div>
  </div>
</div>